import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import classNames from 'classnames'

import TeamsStore from '../../../stores/teams'
import MlsStore from '../../../stores/mls'

import Icon from '../../util/Icon'
import StoreAutoComplete from '../../util/auto_complete/StoreAutoComplete'
import MlsAutocomplete from '../../util/auto_complete/MlsAutocomplete'

@inject('auth', 'websites')
@observer
export default class WebsiteDetails extends Component {
  state = {
    mls_id: '',
    broker_name: '',
    broker_email: '',
    broker_compliance_blurb: '',
    isEditingTeam: false,
    selectedTeam: null,
  }

  websites = this.props.websites

  teams = new TeamsStore()

  componentWillMount() {
    const { params: { website_id } } = this.props

    this.websites.load(website_id)
    this.websites.loadMlsPermissions(website_id)

    this.mlsStore = new MlsStore()
    this.mlsStore.loadMlsInfo(true)
  }

  renderLoading() {
    return (
      <div className="loading">Loading...</div>
    )
  }

  revoke = event => {
    event.preventDefault()
    this.websites.revoke(this.props.params.website_id)
  }

  delete = event => {
    event.preventDefault()
    const confirms = [
      'This will also delete: \n\n Leads, Hotsheets, Searches, Etc.',
      'Are you sure? THIS CANNOT BE UNDONE.',
      'Are you really sure?',
      'Last chance. Really do this?',
    ]
    const bailed = confirms.find(msg => !window.confirm(msg))

    if (!bailed) {
      const { website_id } = this.props.params
      const { team_id } = this.websites.findById(website_id)
      this.websites.delete(website_id).then(() => {
        this.props.router.push(`/teams/${team_id}`)
      })
    }
  }

  activate = event => {
    event.preventDefault()
    this.websites.activate(this.props.params.website_id)
  }

  handleMPInput = (id, field) => event => {
    event.preventDefault()
    this.websites.editMlsPermission(id, { [field]: event.target.value })
  }

  addMP = event => {
    event.preventDefault()

    const { params: { website_id } } = this.props
    const { ...mp } = this.state

    this.websites.createMlsPermission({ ...mp, website_id })
  }

  deleteMP = (id) => event => {
    event.preventDefault()
    this.websites.deleteMlsPermission(id)
  }

  renderRevokeButton() {
    const { user } = this.props.auth
    if (!user.admin && !user.broker) {
      return
    }

    const website = this.websites.findById(this.props.params.website_id)
    if (!website.revoked) {
      return (
        <a className={classNames('button', 'danger')} onClick={this.revoke}>Archive Website</a>
      )
    }
  }

  renderDeleteButton() {
    if (this.props.auth.user.admin) {
      return (
        <a className={classNames('button', 'danger')} onClick={this.delete}>Delete Website</a>
      )
    }
  }

  renderActivateButton() {
    const { user } = this.props.auth
    const canActivate = user.admin || user.broker
    const website = this.websites.findById(this.props.params.website_id)
    if (canActivate && !website.active && !website.license_revoked) {
      return (
        <a className={classNames('button', 'good')} onClick={this.activate}>Activate Website</a>
      )
    }
  }

  renderInstalled() {
    const website = this.websites.findById(this.props.params.website_id)
    if (website.provisioned) {
      return (
        <li><strong>Provisioned at:</strong> <a href={website.default_url}>{website.default_url}</a> (<i><a href={website.default_url + 'diagnostics'}>Diagnostics Page</a></i>)</li>
      )
    }
  }

  handleEditTeam = event => {
    event.preventDefault()
    this.teams.load()
    this.setState({ isEditingTeam: true })
  }

  handleSelectTeam = team => {
    this.setState({ selectedTeam: team })
  }

  handleSaveTeam = event => {
    event.preventDefault()
    const { selectedTeam } = this.state
    if (!selectedTeam) {
      alert('Please select a team')
      return
    }
    const website = this.websites.findById(this.props.params.website_id)
    website.team_name = selectedTeam.name
    website.team_id = selectedTeam.id
    this.websites.update(website).then(() => {
      this.setState({
        isEditingTeam: false,
        selectedTeam: null,
      })
    })
  }

  handleCancelTeam = event => {
    event.preventDefault()
    this.setState({
      isEditingTeam: false,
      selectedTeam: null,
    })
  }

  /*
   * Given an array, return an array of twice the size
   * with each element repeated once
   */
  doubleUp = xs => {
    let out = []

    for (const x of xs) {
      out.push(x)
      out.push(x)
    }

    return out
  }

  renderSoldDataToggle(mp) {
    const mls = this.mlsStore.mlsList.find((m) => m.mls_id === mp.mls_id)
    const sold_data = mls && mls.mls_compliance && mls.mls_compliance.sold_data
    if (!sold_data) {
      return null
    }
    return (
        <div>
          <input className="display-inline" type="checkbox" id="sold_data" name="sold_data" value="true" onChange={this.handleRemoveSoldData(mp.id , 'remove_sold_data' , !mp.remove_sold_data)} checked={mp.remove_sold_data || false}/>
          <label className="display-inline" htmlFor="sold_data">&nbsp; Revoke Sold Data</label>
        </div>
    )
  }

  handleRemoveSoldData = (id , field , value) => event => {
    event.preventDefault()
    this.websites.editMlsPermission(id, { [field]: value })
  }

  render() {
    const {broker_name, broker_email, broker_compliance_blurb, isEditingTeam} = this.state

    if (!this.websites.loaded) return this.renderLoading()

    const website = this.websites.findById(this.props.params.website_id)

    if (!website) {
      // rerenders after deleting website before redirecting.
      return <div className="loading">Loading...</div>
    }

    let websiteStatus = website.status
    let licenseRevokedHTML
    let licenseRevokedStatusHTML
    if (website.license_revoked) {
      licenseRevokedHTML = <strong className="website-status-revoked">[LICENSE REVOKED]</strong>
      licenseRevokedStatusHTML = <em style={{color: '#999'}}>(due to license being revoked)</em>
      websiteStatus = 'revoked'
    } else {
      if (website.status === 'revoked') {
        websiteStatus = 'archived'
      }
    }


    const editTeamButton = this.props.auth.user.admin ? (
      isEditingTeam ? (
        <span>
          <button onClick={this.handleSaveTeam}>Save</button>
          {' '}
          <button onClick={this.handleCancelTeam}>Cancel</button>
        </span>
      ) : (
        <button onClick={this.handleEditTeam}>Edit</button>
      )
    ) : null

    const teamLink = isEditingTeam ? (
      <StoreAutoComplete
        placeholder="Choose A Team"
        onSelect={this.handleSelectTeam}
        store={this.teams} />
    ) : (
      <Link to={`/teams/${website.team_id}`}> { website.team_name }</Link >
    )

    return (
      <div className="container padded website">
        <div className="panel full padded">
          <h2 className="title">Website: {website.name}</h2>

          <ul>
            <li><strong>Team:</strong> {teamLink} {licenseRevokedHTML} {editTeamButton}</li>
            {this.renderInstalled()}
            <li><strong>Status:</strong> <span className={`website-status-${website.status}`}>{websiteStatus}</span> {licenseRevokedStatusHTML}</li>
          </ul>

          <div className="button-group">
            {this.renderActivateButton()}
            {this.renderRevokeButton()}
            {this.renderDeleteButton()}
          </div>
        </div>

        {this.websites.mlsPermissionsLoaded && <form className="panel full padded" onSubmit={this.addMP}>
          <h3>MLS Permissions:</h3>
          <table className="zebra2">
            <thead>
            <tr>
              <th style={{'width':'22%'}}>MLS</th>
              <th colSpan="2">Broker Settings</th>
              <th></th>
            </tr>
            </thead>
            <tbody className="padded">
            {this.doubleUp(this.websites.mls_permissions).map((mp,i) => (i % 2 === 0) ? (
                <tr key={i}>
                  <td>{mp.mls_id.toUpperCase()} &ndash; {mp.mls_name}</td>
                  <td>{this.renderSoldDataToggle(mp)}</td>
                  <td><input onInput={this.handleMPInput(mp.id, 'broker_name' )} defaultValue={mp.broker_name} placeholder="Broker's name" /></td>
                  <td><input onInput={this.handleMPInput(mp.id, 'broker_email')} defaultValue={mp.broker_email} placeholder="Broker's email" /></td>
                  <td rowSpan="2"><a href="#" onClick={this.deleteMP(mp.id)}><Icon icon="trash" className="danger" /></a></td>
                </tr>
              ) : (
                <tr key={i}>
                  <td></td>
                  <td></td>
                  <td colSpan="2">
                    <textarea onInput={this.handleMPInput(mp.id, 'broker_compliance_blurb')} 
                      defaultValue={mp.broker_compliance_blurb} placeholder="Broker's compliance blurb"/>
                  </td>
                </tr>
              )
            )}


            <tr>
              <td>
                <MlsAutocomplete
                  mlsStore={this.mlsStore}
                  onSelect={record => this.setState({mls_id: record.mls_id})}
                />
              </td>
              <td></td>
              <td><input value={broker_name}  onChange={e => this.setState({ broker_name: e.target.value })} 
                placeholder="Broker's name" /></td>
              <td><input value={broker_email} onChange={e => this.setState({ broker_email: e.target.value })} 
                placeholder="Broker's email" /></td>
              <td rowSpan="2"><button>+ Add</button></td>
            </tr>
            <tr>
              <td />
              <td />
              <td colSpan="2">
                <textarea onChange={e => this.setState({ broker_compliance_blurb: e.target.value } )} 
                  value={broker_compliance_blurb} placeholder="Broker's compliance blurb"/>
              </td>
            </tr>
            </tbody>
          </table>
        </form>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Websites/Details.js